// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/ABCFavorit-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/ABCFavorit-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ABC Favorit Font Faces */
@font-face {
  font-family: "ABC Favorit";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "ABC Favorit";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: 500;
  font-style: normal;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

body {
  font-family:
    "ABC Favorit",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    sans-serif;
  background-color: #f5f5f5;
  color: #333;
}

@media (min-width: 769px) {
  .button-text-full {
    display: inline;
  }

  .button-text-mobile {
    display: none;
  }
}

/* Responsive sidebar/action sheet styles */
.sidebar-wrapper {
  position: relative;
  flex: 0 0 55.6%;
  display: flex;
  height: 100%;
  width: 100%;
}

/* Desktop sidebar - only show on desktop */
.desktop-sideba.r {
  display: block;
  height: 100%;
  width: 100%;
}

.mobile-actionsheet {
  display: none;
}

/* Mobile action sheet - only show on mobile */
@media (max-width: 800px) {
  .desktop-sidebar {
    display: none;
  }

  .mobile-actionsheet {
    display: block;
  }
}

/* Action Sheet Styles */
.action-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: height 0.3s ease-out;
  overflow: hidden;
}

.action-sheet-handle {
  padding: 12px 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  background: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.action-sheet-handle-bar {
  width: 40px;
  height: 4px;
  background: #d1d5db;
  border-radius: 2px;
}

.action-sheet-content {
  height: calc(100% - 40px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.button-container {
  padding: 0 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.main-content {
  height: calc(100vh - 80px);
  display: flex;
  overflow: hidden;
}

.map-container {
  flex: 1;
  position: relative;
  min-width: 0;
  order: 2;
}

.services-header {
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
}

.services-header h2 {
  font-size: 20px;
  margin-bottom: 8px;
  color: #2d3748;
}

.services-header p {
  color: #718096;
  font-size: 14px;
  margin-bottom: 12px;
}

.services-count {
  font-size: 12px;
  color: #4a5568;
  font-weight: 500;
  padding-left: 20px;
}

.services-list {
  padding: 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-content: start;
  grid-auto-rows: max-content;
}

/* Responsive grid breakpoints */
@media (max-width: 1200px) {
  .services-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 800px) {
  .main-content {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    max-width: none;
    min-width: 0;
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
    height: 40vh;
  }

  .map-container {
    height: 60vh;
  }

  .services-list {
    grid-template-columns: 1fr;
    padding: 16px;
  }
}

/* Card styles moved to src/components/Card/Card.css */

.service-item {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.service-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e0;
}

.service-item.selected {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.service-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.service-image {
  width: 100%;
  height: 180px;
  margin-bottom: 0;
  border-radius: 0;
  overflow: hidden;
  background: #f7fafc;
  flex-shrink: 0;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.service-name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #2d3748;
}

.service-type {
  font-size: 12px;
  color: #4a5568;
  background: #edf2f7;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  margin-bottom: 8px;
}

.service-location {
  font-size: 13px;
  color: #718096;
  margin-bottom: 8px;
}

.service-description {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.5;
  margin-bottom: 12px;
}

.service-link {
  color: #4299e1;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
}

.service-link:hover {
  text-decoration: underline;
}

.no-services {
  text-align: center;
  padding: 40px 20px;
  color: #718096;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #4a5568;
}

.error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.error h2 {
  color: #e53e3e;
  margin-bottom: 12px;
}

.error p {
  color: #718096;
  margin-bottom: 20px;
}

.retry-button {
  background: #000000;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.retry-button:hover {
  background: #333333;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 0px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h2 {
  font-size: 20px;
  color: #2d3748;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #718096;
}

.close-button:hover {
  color: #4a5568;
}

.service-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #4a5568;
}

.form-section {
  margin-bottom: 24px;
}

.section-heading {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
}

.small-label {
  font-size: 12px !important;
  font-weight: 400 !important;
}

.image-upload-area {
  width: 100%;
  height: 200px;
  background-color: #f7f7f7;
  border: 2px dashed #cbd5e0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
}

.image-upload-area:hover {
  border-color: #4299e1;
  background-color: #f0f8ff;
}

.image-upload-area.has-image {
  padding: 0;
  border: none;
}

.image-upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #718096;
}

.image-upload-placeholder-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.image-upload-placeholder-text {
  font-size: 16px;
  font-weight: 500;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  color: white;
  font-weight: 500;
}

.image-upload-area:hover .image-overlay {
  opacity: 1;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 0px;
  font-size: 14px;
  font-family:
    "ABC Favorit",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    sans-serif;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row .form-group {
  flex: 1;
}

.location-input {
  display: flex;
  gap: 8px;
}

.location-input input {
  flex: 1;
}

.location-search-button {
  background: #000000;
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 25px;
  cursor: pointer;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.location-search-button:hover {
  background: #333333;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.cancel-button {
  background: #edf2f7;
  color: #4a5568;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cancel-button:hover {
  background: #e2e8f0;
}

.form-note {
  font-size: 12px;
  color: #718096;
  margin-top: 16px;
  text-align: center;
}

/* Image Uploader Styles */
.image-uploader {
  margin: 16px 0;
}

.file-previews {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.file-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f6f5f1;
  border: 1px solid #e2e8f0;
  border-radius: 0px;
  padding: 12px;
}

.thumbnail-container {
  position: relative;
  flex-shrink: 0;
}

.thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 0px;
  border: 1px solid #e2e8f0;
}

.remove-thumbnail {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  background: #e53e3e;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-thumbnail:hover {
  background: #c53030;
}

.file-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.file-name {
  font-weight: 500;
  color: #2d3748;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: #718096;
  font-size: 12px;
}

.upload-note {
  color: #718096;
  font-size: 12px;
  margin-top: 8px;
}

/* Map Popup Styles */
.mapboxgl-popup-content {
  padding: 0 !important;
  border-radius: 0px !important;
}

.map-popup {
  max-width: 250px;
}

/* Image Slideshow Styles */
.image-slideshow {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.slideshow-container {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 0px;
  overflow: hidden;
  background: #f7fafc;
}

.slideshow-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}

.slideshow-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  z-index: 10;
}

.slideshow-nav:hover {
  background: rgba(0, 0, 0, 0.8);
}

.slideshow-nav.prev {
  left: 8px;
}

.slideshow-nav.next {
  right: 8px;
}

.slideshow-indicators {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 10;
}

.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.2s;
}

.indicator.active {
  background: rgba(255, 255, 255, 0.9);
}

.slideshow-counter {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

/* Enhanced Map Popup Styles */
.popup-content {
  padding: 12px;
  max-width: 280px;
}

.popup-images {
  margin-bottom: 12px;
}

.popup-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.popup-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: #2d3748;
}

.popup-type {
  font-size: 12px;
  color: #4a5568;
  background: #edf2f7;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  width: fit-content;
  margin: 0;
}

.popup-location {
  font-size: 13px;
  color: #718096;
  margin: 0;
}

.popup-description {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.4;
  margin: 0;
}

.popup-link {
  color: #4299e1;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
}

.popup-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 800px) {
  .main-content {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: 50%;
    border-left: none;
    border-top: 1px solid #e2e8f0;
  }

  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .location-input {
    flex-direction: column;
  }

  .location-search-button {
    align-self: flex-start;
  }

  .slideshow-container {
    height: 150px;
  }

  .popup-content {
    max-width: 240px;
  }
}

/* Dynamic Fields Styles */
.dynamic-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.service-select {
  flex: 2;
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 0px;
  font-size: 14px;
  background: white;
}

.role-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 0px;
  font-size: 14px;
}

.remove-button {
  background: #e53e3e;
  color: white;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-button:hover {
  background: #c53030;
}

.add-field-button {
  background: #f7fafc;
  color: #4a5568;
  border: 1px dashed #cbd5e0;
  padding: 8px 12px;
  border-radius: 0px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.add-field-button:hover {
  background: #edf2f7;
  border-color: #a0aec0;
}

.location-options {
  margin-bottom: 12px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  margin: 8px 0;
  line-height: 1.4;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
  margin-top: 2px;
  margin-right: 8px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* Modal form padding */
.modal-content form {
  padding: 0 20px 20px 20px;
}

/* React Select styling to match form inputs */
.select__control {
  border: 1px solid #cbd5e0 !important;
  border-radius: 0px !important;
  min-height: 44px;
  font-size: 14px;
}

.select__control:hover {
  border-color: #cbd5e0 !important;
}

.select__control--is-focused {
  border-color: #4299e1 !important;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
}

/* Add Button */
.add-button {
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: #2d3748;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
  font-weight: bold;
  margin-left: 8px;
}

.add-button:hover {
  background: #1a202c;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-section {
  flex-shrink: 0;
}

.services-header {
  flex-shrink: 0;
}

.select__multi-value {
  background-color: #edf2f7 !important;
  border-radius: 0px !important;
}

.select__multi-value__label {
  color: #2d3748 !important;
  font-size: 14px;
}

.select__multi-value__remove {
  border-radius: 0px !important;
}

.select__multi-value__remove:hover {
  background-color: #e53e3e !important;
  color: white !important;
}

/* File input styling */
.form-group input[type="file"] {
  display: none;
}

/* Loading spinner animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.file-selected {
  margin-top: 8px;
  font-size: 14px;
  color: #4a5568;
}

/* Events Section */
.events-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* Event hover popup styling */
.event-hover-popup .popup-content {
  min-width: 250px;
  max-width: 350px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.event-hover-popup .popup-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 12px 0;
  color: #e53e3e;
}

.event-connections .connections-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: #333;
}

.event-connections .connections-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.connection-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 4px 0;
  font-size: 13px;
}

.connection-item.organizer {
  color: #f59e0b;
}

.connection-item.participant {
  color: #10b981;
}

.connection-type {
  font-size: 12px;
  text-align: center;
}

.connection-name {
  font-weight: 500;
  flex: 1;
}

.connection-role {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.connection-image {
  object-fit: cover;
  border-radius: 50%;
}

.no-connections {
  font-size: 13px;
  color: #666;
  margin: 0;
  font-style: italic;
}

/* Connection overlay */
.connection-overlay {
  pointer-events: none;
}

/* Products Styles */
.products-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-item {
  background: white;
  border: 1px solid #e2e8f0;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.product-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e0;
}

.product-content {
  padding: 16px;
}

.product-image {
  width: 100%;
  height: 120px;
  margin-bottom: 12px;
  border-radius: 0px;
  overflow: hidden;
  background: #f7fafc;
  position: relative;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-credits {
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2px 6px;
  font-size: 10px;
}

.product-name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #2d3748;
}

.product-type {
  font-size: 12px;
  color: #4a5568;
  background: #edf2f7;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  margin-bottom: 8px;
}

.product-price {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 4px;
}

.stock-status {
  font-size: 12px;
  font-weight: 400;
}

.stock-status.true,
.stock-status.yes {
  color: #38a169;
}

.stock-status.false,
.stock-status.no {
  color: #e53e3e;
}

.product-location {
  font-size: 13px;
  color: #718096;
  margin-bottom: 8px;
}

.product-description {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.5;
  margin-bottom: 12px;
}

.product-link {
  color: #4299e1;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
}

.product-link:hover {
  text-decoration: underline;
}

.no-products {
  text-align: center;
  padding: 40px 20px;
  color: #718096;
}

/* Profile Image Preview Styles */
.profile-image-preview {
  position: relative;
  width: 100%;
  margin: 0 0 32px 0;
  background: #ffffff;
  padding-bottom: 50px;
}

.cover-image-container {
  width: 100%;
  height: 160px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-upload-zone {
  border: 2px dashed #cbd5e0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cover-upload-zone:hover {
  border-color: #a0aec0;
  background-color: #f7fafc !important;
}

.cover-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #718096;
  font-size: 14px;
  pointer-events: none;
}

.cover-placeholder svg {
  margin-bottom: 8px;
  opacity: 0.7;
}

.profile-image-container {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.profile-image-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #ffffff;
  border: 3px solid #ffffff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.profile-upload-zone {
  border: 2px dashed #cbd5e0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.profile-upload-zone:hover {
  border-color: #a0aec0;
  background-color: #f7fafc;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #718096;
  background: #f9f9f9;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* Image Upload Section Styles */
.image-upload-section {
  margin-bottom: 24px;
}

.remove-buttons {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
  display: flex;
  gap: 8px;
}

.remove-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e53e3e;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  transition: background-color 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.remove-button:hover {
  background: #c53030;
}

.cover-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
}

.profile-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
}

.upload-help {
  text-align: center;
  font-size: 13px;
  color: #718096;
  margin: 0;
  line-height: 1.4;
}

/* Creator Avatars Overlay */
.creator-avatars-container {
  position: absolute;
  bottom: 42px;
  left: 16px;
  display: flex;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.creator-avatars-container:hover {
  transform: scale(1.05);
}

.creator-avatar {
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.creator-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.creator-avatar-initials {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  text-align: center;
}

.creator-avatar-more {
  background: #374151;
  color: white;
  font-size: 10px;
  font-weight: 500;
}

/* Creator Profile Dialog */
.creator-dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.creator-dialog {
  background: white;
  border-radius: 12px;
  max-width: 480px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.creator-dialog-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.creator-dialog-close:hover {
  background: #f3f4f6;
}

.creator-dialog-title {
  padding: 24px 24px 16px;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #111827;
}

.creator-profiles {
  padding: 0 24px 24px;
}

.creator-profile {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}

.creator-profile:last-child {
  border-bottom: none;
}

.creator-profile-avatar {
  flex-shrink: 0;
}

.creator-profile-image,
.creator-profile-initials {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.creator-profile-image {
  object-fit: cover;
}

.creator-profile-initials {
  background: #f6f5f1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #374151;
  font-size: 18px;
}

.creator-profile-info {
  flex: 1;
  min-width: 0;
}

.creator-profile-name {
  margin: 0 0 4px 0;
  font-size: 1.125rem;
  font-weight: 500;
  color: #111827;
}

.creator-profile-category {
  margin: 0 0 8px 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.creator-profile-location {
  margin: 0 0 8px 0;
  font-size: 0.875rem;
  color: #6b7280;
}

.creator-profile-description {
  margin: 0;
  font-size: 0.875rem;
  color: #374151;
  line-height: 1.5;
}

/* Detail Pages Styling */
.detail-page {
  min-height: 100vh;
  background-color: #ffffff;
  overflow-y: auto;
  font-family:
    "ABC Favorit",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
}

.detail-header {
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-button {
  color: #222222;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.back-button:hover {
  background-color: #f7f7f7;
}

.detail-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 48px;
  align-items: start;
}

@media (max-width: 1024px) {
  .detail-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.detail-main {
  padding: 40px 0;
}

.detail-gallery {
  margin-bottom: 32px;
}

.gallery-main {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16/9;
  background-color: #f7f7f7;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.gallery-creators {
  position: absolute;
  bottom: 16px;
  left: 16px;
}

.gallery-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  transition: background-color 0.2s ease;
}

.gallery-nav:hover {
  background-color: rgba(255, 255, 255, 1);
}

.gallery-nav.prev {
  left: 16px;
}

.gallery-nav.next {
  right: 16px;
}

.gallery-dots {
  position: absolute;
  bottom: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
}

.gallery-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.gallery-dot.active {
  background-color: rgba(255, 255, 255, 1);
}

.detail-info {
  color: #222222;
}

.detail-title-section {
  margin-bottom: 32px;
}

.detail-title {
  font-size: 32px;
  font-weight: 500;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.detail-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.detail-type {
  background-color: #f7f7f7;
  color: #222222;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
}

.detail-location {
  color: #717171;
  font-size: 14px;
}

.detail-description h2 {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 16px 0;
}

.detail-description p {
  font-size: 16px;
  line-height: 1.6;
  color: #222222;
  margin: 0;
}

.detail-actions {
  margin-top: 32px;
}

.detail-primary-button {
  background-color: #ff385c;
  color: white;
  text-decoration: none;
  padding: 14px 24px;
  border-radius: 8px;
  font-weight: 500;
  display: inline-block;
  transition: background-color 0.2s ease;
}

.detail-primary-button:hover {
  background-color: #d50027;
  color: white;
}

.detail-sidebar {
  padding: 40px 0;
  position: sticky;
  top: 100px;
}

.detail-card {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.detail-card h3 {
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 16px 0;
  color: #222222;
}

.detail-contact-item {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-contact-item:last-child {
  margin-bottom: 0;
}

.detail-contact-item strong {
  font-weight: 500;
  color: #222222;
  font-size: 14px;
}

.detail-contact-item span,
.detail-contact-item a {
  color: #717171;
  font-size: 14px;
  text-decoration: none;
}

.detail-contact-item a:hover {
  color: #222222;
  text-decoration: underline;
}

.product-price {
  font-weight: 500;
  color: #222222;
  font-size: 16px;
}

.stock-status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.stock-status.true,
.stock-status.yes {
  background-color: #d4edda;
  color: #155724;
}

.stock-status.false,
.stock-status.no {
  background-color: #f8d7da;
  color: #721c24;
}

.creator-item {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.creator-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.creator-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s ease;
}

.creator-link:hover {
  opacity: 0.8;
}

.creator-avatar-small {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.creator-avatar-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.creator-initials-small {
  font-size: 14px;
  font-weight: 500;
  color: #717171;
}

.creator-info {
  flex: 1;
}

.creator-name {
  font-weight: 500;
  color: #222222;
  font-size: 14px;
  margin-bottom: 2px;
}

.creator-type {
  color: #717171;
  font-size: 12px;
}

/* Item Detail View in Sidebar */
.item-detail-view {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-back-button {
  background: none;
  border: none;
  color: #222222;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  align-self: flex-start;
  font-family: inherit;
}

.detail-back-button:hover {
  background-color: #f7f7f7;
}

.detail-image {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 12px;
  background-color: #f7f7f7;
}

.detail-header-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item-title {
  font-size: 24px;
  font-weight: 500;
  color: #222222;
  margin: 0;
}

.detail-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.detail-location-text {
  font-size: 14px;
  color: #717171;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-section-title {
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  margin: 0;
}

.detail-description-text {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

.detail-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
}

.detail-info-item strong {
  color: #222222;
  font-weight: 500;
}

.detail-link {
  color: #2563eb;
  text-decoration: none;
}

.detail-link:hover {
  text-decoration: underline;
}

.detail-connections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.connection-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background-color: #f7f7f7;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}

.connection-item:hover {
  background-color: #e5e5e5;
}

.connection-name {
  font-size: 14px;
  color: #222222;
  font-weight: 500;
  flex: 1;
}

.connection-type {
  font-size: 12px;
  color: #717171;
}

/* Member Detail Page - Behance Style */

.listing-wrapper {
  min-height: 100vh;
  background-color: #ffffff;
  font-family:
    "ABC Favorit",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
}

.listing-cover-image {
  width: 100%;
  height: 320px;
  overflow: hidden;
  background-color: #f0f0f0;
}

.listing-cover-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.listing-detail-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 24px;
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 60px;
  align-items: start;
}

@media (max-width: 1024px) {
  .listing-detail-container {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

/* Sidebar */
.listing-sidebar {
  position: sticky;
  top: 100px;
}

.listing-profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 20px;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.listing-profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.listing-name {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #111827;
}

.listing-website-link {
  display: inline-block;
  color: #3b82f6;
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 16px;
  transition: color 0.2s ease;
}

.listing-website-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.listing-description {
  margin: 20px 0;
  padding: 0;
}

.listing-description p {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  margin: 0;
}

.listing-location {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
  margin-top: 16px;
}

.listing-location-icon {
  font-size: 16px;
}

.listing-contact-button {
  width: 100%;
  padding: 10px 16px;
  margin-top: 20px;
  background-color: #111827;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.listing-contact-button:hover {
  background-color: #374151;
}

.listing-social-links {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: flex-start;
}

.listing-social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f3f4f6;
  color: #374151;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.listing-social-icon:hover {
  background-color: #e5e7eb;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.listing-event-date {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
  margin-top: 16px;
  font-weight: 500;
}

.listing-date-icon {
  font-size: 16px;
}

/* Organizers Section */
.listing-organizers {
  margin-bottom: 32px;
  padding: 20px;
  background-color: #f9fafb;
  border-radius: 8px;
}

.listing-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
}

.listing-organizers-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.listing-organizer-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #ffffff;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid #e5e7eb;
}

.listing-organizer-item:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.listing-organizer-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.listing-organizer-name {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* Main Content Area */
.listing-content {
  min-height: 400px;
}

/* Tabs */
.listing-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 32px;
}

.listing-tab {
  background: none;
  border: none;
  padding: 12px 0;
  font-size: 15px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  font-family:
    "ABC Favorit",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
}

.listing-tab:hover {
  color: #111827;
}

.listing-tab.active {
  color: #111827;
}

/* Mobile Stacking */
@media (max-width: 1024px) {
  .listing-cover-image {
    height: 240px;
  }

  .listing-sidebar {
    position: static;
    text-align: center;
  }

  .listing-profile-image {
    margin: 0 auto 20px;
  }

  .listing-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .listing-tab {
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;;;;;;cAMY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;AACF;;AAEA,sDAAsD;;AAEtD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;;;;;cAMY;AACd;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB;;wCAEsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB;;;;;;cAMY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,iBAAiB;EACjB,yBAAyB;EACzB;;;;;;cAMY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB;;;;;;cAMY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* ABC Favorit Font Faces */\n@font-face {\n  font-family: \"ABC Favorit\";\n  src: url(\"../assets/fonts/ABCFavorit-Book.otf\") format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ABC Favorit\";\n  src: url(\"../assets/fonts/ABCFavorit-Medium.otf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\nbody {\n  font-family:\n    \"ABC Favorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    sans-serif;\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n@media (min-width: 769px) {\n  .button-text-full {\n    display: inline;\n  }\n\n  .button-text-mobile {\n    display: none;\n  }\n}\n\n/* Responsive sidebar/action sheet styles */\n.sidebar-wrapper {\n  position: relative;\n  flex: 0 0 55.6%;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n/* Desktop sidebar - only show on desktop */\n.desktop-sideba.r {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.mobile-actionsheet {\n  display: none;\n}\n\n/* Mobile action sheet - only show on mobile */\n@media (max-width: 800px) {\n  .desktop-sidebar {\n    display: none;\n  }\n\n  .mobile-actionsheet {\n    display: block;\n  }\n}\n\n/* Action Sheet Styles */\n.action-sheet {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  transition: height 0.3s ease-out;\n  overflow: hidden;\n}\n\n.action-sheet-handle {\n  padding: 12px 0;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  background: white;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.action-sheet-handle-bar {\n  width: 40px;\n  height: 4px;\n  background: #d1d5db;\n  border-radius: 2px;\n}\n\n.action-sheet-content {\n  height: calc(100% - 40px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.button-container {\n  padding: 0 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.main-content {\n  height: calc(100vh - 80px);\n  display: flex;\n  overflow: hidden;\n}\n\n.map-container {\n  flex: 1;\n  position: relative;\n  min-width: 0;\n  order: 2;\n}\n\n.services-header {\n  padding: 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.services-header h2 {\n  font-size: 20px;\n  margin-bottom: 8px;\n  color: #2d3748;\n}\n\n.services-header p {\n  color: #718096;\n  font-size: 14px;\n  margin-bottom: 12px;\n}\n\n.services-count {\n  font-size: 12px;\n  color: #4a5568;\n  font-weight: 500;\n  padding-left: 20px;\n}\n\n.services-list {\n  padding: 24px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  align-content: start;\n  grid-auto-rows: max-content;\n}\n\n/* Responsive grid breakpoints */\n@media (max-width: 1200px) {\n  .services-list {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 800px) {\n  .main-content {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n    border-right: none;\n    border-bottom: 1px solid #e2e8f0;\n    height: 40vh;\n  }\n\n  .map-container {\n    height: 60vh;\n  }\n\n  .services-list {\n    grid-template-columns: 1fr;\n    padding: 16px;\n  }\n}\n\n/* Card styles moved to src/components/Card/Card.css */\n\n.service-item {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 0;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.service-item:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e0;\n}\n\n.service-item.selected {\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.service-content {\n  padding: 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.service-image {\n  width: 100%;\n  height: 180px;\n  margin-bottom: 0;\n  border-radius: 0;\n  overflow: hidden;\n  background: #f7fafc;\n  flex-shrink: 0;\n}\n\n.service-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.service-name {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: #2d3748;\n}\n\n.service-type {\n  font-size: 12px;\n  color: #4a5568;\n  background: #edf2f7;\n  padding: 2px 8px;\n  border-radius: 12px;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n.service-location {\n  font-size: 13px;\n  color: #718096;\n  margin-bottom: 8px;\n}\n\n.service-description {\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.service-link {\n  color: #4299e1;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.service-link:hover {\n  text-decoration: underline;\n}\n\n.no-services {\n  text-align: center;\n  padding: 40px 20px;\n  color: #718096;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 18px;\n  color: #4a5568;\n}\n\n.error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  text-align: center;\n  padding: 20px;\n}\n\n.error h2 {\n  color: #e53e3e;\n  margin-bottom: 12px;\n}\n\n.error p {\n  color: #718096;\n  margin-bottom: 20px;\n}\n\n.retry-button {\n  background: #000000;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.retry-button:hover {\n  background: #333333;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 0px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  color: #2d3748;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #718096;\n}\n\n.close-button:hover {\n  color: #4a5568;\n}\n\n.service-form {\n  padding: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.form-section {\n  margin-bottom: 24px;\n}\n\n.section-heading {\n  font-size: 18px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 8px;\n}\n\n.small-label {\n  font-size: 12px !important;\n  font-weight: 400 !important;\n}\n\n.image-upload-area {\n  width: 100%;\n  height: 200px;\n  background-color: #f7f7f7;\n  border: 2px dashed #cbd5e0;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n.image-upload-area:hover {\n  border-color: #4299e1;\n  background-color: #f0f8ff;\n}\n\n.image-upload-area.has-image {\n  padding: 0;\n  border: none;\n}\n\n.image-upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #718096;\n}\n\n.image-upload-placeholder-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.image-upload-placeholder-text {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.uploaded-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  color: white;\n  font-weight: 500;\n}\n\n.image-upload-area:hover .image-overlay {\n  opacity: 1;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 0px;\n  font-size: 14px;\n  font-family:\n    \"ABC Favorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    sans-serif;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.location-input {\n  display: flex;\n  gap: 8px;\n}\n\n.location-input input {\n  flex: 1;\n}\n\n.location-search-button {\n  background: #000000;\n  color: white;\n  border: none;\n  padding: 12px 16px;\n  border-radius: 25px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.location-search-button:hover {\n  background: #333333;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.cancel-button {\n  background: #edf2f7;\n  color: #4a5568;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cancel-button:hover {\n  background: #e2e8f0;\n}\n\n.form-note {\n  font-size: 12px;\n  color: #718096;\n  margin-top: 16px;\n  text-align: center;\n}\n\n/* Image Uploader Styles */\n.image-uploader {\n  margin: 16px 0;\n}\n\n.file-previews {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.file-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #f6f5f1;\n  border: 1px solid #e2e8f0;\n  border-radius: 0px;\n  padding: 12px;\n}\n\n.thumbnail-container {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.thumbnail {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 0px;\n  border: 1px solid #e2e8f0;\n}\n\n.remove-thumbnail {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 20px;\n  height: 20px;\n  background: #e53e3e;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.remove-thumbnail:hover {\n  background: #c53030;\n}\n\n.file-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.file-name {\n  font-weight: 500;\n  color: #2d3748;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size {\n  color: #718096;\n  font-size: 12px;\n}\n\n.upload-note {\n  color: #718096;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n/* Map Popup Styles */\n.mapboxgl-popup-content {\n  padding: 0 !important;\n  border-radius: 0px !important;\n}\n\n.map-popup {\n  max-width: 250px;\n}\n\n/* Image Slideshow Styles */\n.image-slideshow {\n  position: relative;\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.slideshow-container {\n  position: relative;\n  width: 100%;\n  height: 180px;\n  border-radius: 0px;\n  overflow: hidden;\n  background: #f7fafc;\n}\n\n.slideshow-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.3s ease;\n}\n\n.slideshow-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n  z-index: 10;\n}\n\n.slideshow-nav:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.slideshow-nav.prev {\n  left: 8px;\n}\n\n.slideshow-nav.next {\n  right: 8px;\n}\n\n.slideshow-indicators {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 6px;\n  z-index: 10;\n}\n\n.indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.indicator.active {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.slideshow-counter {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 10;\n}\n\n/* Enhanced Map Popup Styles */\n.popup-content {\n  padding: 12px;\n  max-width: 280px;\n}\n\n.popup-images {\n  margin-bottom: 12px;\n}\n\n.popup-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.popup-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n  color: #2d3748;\n}\n\n.popup-type {\n  font-size: 12px;\n  color: #4a5568;\n  background: #edf2f7;\n  padding: 2px 8px;\n  border-radius: 12px;\n  display: inline-block;\n  width: fit-content;\n  margin: 0;\n}\n\n.popup-location {\n  font-size: 13px;\n  color: #718096;\n  margin: 0;\n}\n\n.popup-description {\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.4;\n  margin: 0;\n}\n\n.popup-link {\n  color: #4299e1;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.popup-link:hover {\n  text-decoration: underline;\n}\n\n/* Responsive Design */\n@media (max-width: 800px) {\n  .main-content {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n    height: 50%;\n    border-left: none;\n    border-top: 1px solid #e2e8f0;\n  }\n\n  .modal-content {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .location-input {\n    flex-direction: column;\n  }\n\n  .location-search-button {\n    align-self: flex-start;\n  }\n\n  .slideshow-container {\n    height: 150px;\n  }\n\n  .popup-content {\n    max-width: 240px;\n  }\n}\n\n/* Dynamic Fields Styles */\n.dynamic-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.field-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.service-select {\n  flex: 2;\n  padding: 8px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 0px;\n  font-size: 14px;\n  background: white;\n}\n\n.role-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 0px;\n  font-size: 14px;\n}\n\n.remove-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.remove-button:hover {\n  background: #c53030;\n}\n\n.add-field-button {\n  background: #f7fafc;\n  color: #4a5568;\n  border: 1px dashed #cbd5e0;\n  padding: 8px 12px;\n  border-radius: 0px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.add-field-button:hover {\n  background: #edf2f7;\n  border-color: #a0aec0;\n}\n\n.location-options {\n  margin-bottom: 12px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  margin: 8px 0;\n  line-height: 1.4;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin: 0;\n  margin-top: 2px;\n  margin-right: 8px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n/* Modal form padding */\n.modal-content form {\n  padding: 0 20px 20px 20px;\n}\n\n/* React Select styling to match form inputs */\n.select__control {\n  border: 1px solid #cbd5e0 !important;\n  border-radius: 0px !important;\n  min-height: 44px;\n  font-size: 14px;\n}\n\n.select__control:hover {\n  border-color: #cbd5e0 !important;\n}\n\n.select__control--is-focused {\n  border-color: #4299e1 !important;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;\n}\n\n/* Add Button */\n.add-button {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: #2d3748;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 18px;\n  font-weight: bold;\n  margin-left: 8px;\n}\n\n.add-button:hover {\n  background: #1a202c;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.search-section {\n  flex-shrink: 0;\n}\n\n.services-header {\n  flex-shrink: 0;\n}\n\n.select__multi-value {\n  background-color: #edf2f7 !important;\n  border-radius: 0px !important;\n}\n\n.select__multi-value__label {\n  color: #2d3748 !important;\n  font-size: 14px;\n}\n\n.select__multi-value__remove {\n  border-radius: 0px !important;\n}\n\n.select__multi-value__remove:hover {\n  background-color: #e53e3e !important;\n  color: white !important;\n}\n\n/* File input styling */\n.form-group input[type=\"file\"] {\n  display: none;\n}\n\n/* Loading spinner animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.file-selected {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n/* Events Section */\n.events-section {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* Event hover popup styling */\n.event-hover-popup .popup-content {\n  min-width: 250px;\n  max-width: 350px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n}\n\n.event-hover-popup .popup-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 12px 0;\n  color: #e53e3e;\n}\n\n.event-connections .connections-title {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.event-connections .connections-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.connection-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.connection-item.organizer {\n  color: #f59e0b;\n}\n\n.connection-item.participant {\n  color: #10b981;\n}\n\n.connection-type {\n  font-size: 12px;\n  text-align: center;\n}\n\n.connection-name {\n  font-weight: 500;\n  flex: 1;\n}\n\n.connection-role {\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n}\n\n.connection-image {\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.no-connections {\n  font-size: 13px;\n  color: #666;\n  margin: 0;\n  font-style: italic;\n}\n\n/* Connection overlay */\n.connection-overlay {\n  pointer-events: none;\n}\n\n/* Products Styles */\n.products-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.product-item {\n  background: white;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.product-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e0;\n}\n\n.product-content {\n  padding: 16px;\n}\n\n.product-image {\n  width: 100%;\n  height: 120px;\n  margin-bottom: 12px;\n  border-radius: 0px;\n  overflow: hidden;\n  background: #f7fafc;\n  position: relative;\n}\n\n.product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-credits {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 2px 6px;\n  font-size: 10px;\n}\n\n.product-name {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: #2d3748;\n}\n\n.product-type {\n  font-size: 12px;\n  color: #4a5568;\n  background: #edf2f7;\n  padding: 2px 8px;\n  border-radius: 12px;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n.product-price {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 4px;\n}\n\n.stock-status {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.stock-status.true,\n.stock-status.yes {\n  color: #38a169;\n}\n\n.stock-status.false,\n.stock-status.no {\n  color: #e53e3e;\n}\n\n.product-location {\n  font-size: 13px;\n  color: #718096;\n  margin-bottom: 8px;\n}\n\n.product-description {\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.product-link {\n  color: #4299e1;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.product-link:hover {\n  text-decoration: underline;\n}\n\n.no-products {\n  text-align: center;\n  padding: 40px 20px;\n  color: #718096;\n}\n\n/* Profile Image Preview Styles */\n.profile-image-preview {\n  position: relative;\n  width: 100%;\n  margin: 0 0 32px 0;\n  background: #ffffff;\n  padding-bottom: 50px;\n}\n\n.cover-image-container {\n  width: 100%;\n  height: 160px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cover-upload-zone {\n  border: 2px dashed #cbd5e0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cover-upload-zone:hover {\n  border-color: #a0aec0;\n  background-color: #f7fafc !important;\n}\n\n.cover-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #718096;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.cover-placeholder svg {\n  margin-bottom: 8px;\n  opacity: 0.7;\n}\n\n.profile-image-container {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n}\n\n.profile-image-circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: #ffffff;\n  border: 3px solid #ffffff;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.profile-upload-zone {\n  border: 2px dashed #cbd5e0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.profile-upload-zone:hover {\n  border-color: #a0aec0;\n  background-color: #f7fafc;\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profile-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #718096;\n  background: #f9f9f9;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n/* Image Upload Section Styles */\n.image-upload-section {\n  margin-bottom: 24px;\n}\n\n.remove-buttons {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  z-index: 10;\n  display: flex;\n  gap: 8px;\n}\n\n.remove-button {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #e53e3e;\n  border: none;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 1;\n  transition: background-color 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.remove-button:hover {\n  background: #c53030;\n}\n\n.cover-remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 3;\n}\n\n.profile-remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 3;\n}\n\n.upload-help {\n  text-align: center;\n  font-size: 13px;\n  color: #718096;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Creator Avatars Overlay */\n.creator-avatars-container {\n  position: absolute;\n  bottom: 42px;\n  left: 16px;\n  display: flex;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.creator-avatars-container:hover {\n  transform: scale(1.05);\n}\n\n.creator-avatar {\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid white;\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.creator-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.creator-avatar-initials {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n  text-align: center;\n}\n\n.creator-avatar-more {\n  background: #374151;\n  color: white;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n/* Creator Profile Dialog */\n.creator-dialog-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.creator-dialog {\n  background: white;\n  border-radius: 12px;\n  max-width: 480px;\n  width: 100%;\n  max-height: 80vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.creator-dialog-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #6b7280;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.creator-dialog-close:hover {\n  background: #f3f4f6;\n}\n\n.creator-dialog-title {\n  padding: 24px 24px 16px;\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.creator-profiles {\n  padding: 0 24px 24px;\n}\n\n.creator-profile {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.creator-profile:last-child {\n  border-bottom: none;\n}\n\n.creator-profile-avatar {\n  flex-shrink: 0;\n}\n\n.creator-profile-image,\n.creator-profile-initials {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n}\n\n.creator-profile-image {\n  object-fit: cover;\n}\n\n.creator-profile-initials {\n  background: #f6f5f1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  color: #374151;\n  font-size: 18px;\n}\n\n.creator-profile-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.creator-profile-name {\n  margin: 0 0 4px 0;\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.creator-profile-category {\n  margin: 0 0 8px 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.creator-profile-location {\n  margin: 0 0 8px 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.creator-profile-description {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #374151;\n  line-height: 1.5;\n}\n\n/* Detail Pages Styling */\n.detail-page {\n  min-height: 100vh;\n  background-color: #ffffff;\n  overflow-y: auto;\n  font-family:\n    \"ABC Favorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n}\n\n.detail-header {\n  padding: 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #ffffff;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.back-button {\n  color: #222222;\n  text-decoration: none;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.back-button:hover {\n  background-color: #f7f7f7;\n}\n\n.detail-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 48px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .detail-content {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n}\n\n.detail-main {\n  padding: 40px 0;\n}\n\n.detail-gallery {\n  margin-bottom: 32px;\n}\n\n.gallery-main {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n  background-color: #f7f7f7;\n}\n\n.gallery-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.gallery-creators {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n\n.gallery-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  color: #222222;\n  transition: background-color 0.2s ease;\n}\n\n.gallery-nav:hover {\n  background-color: rgba(255, 255, 255, 1);\n}\n\n.gallery-nav.prev {\n  left: 16px;\n}\n\n.gallery-nav.next {\n  right: 16px;\n}\n\n.gallery-dots {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  display: flex;\n  gap: 8px;\n}\n\n.gallery-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: none;\n  background-color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.gallery-dot.active {\n  background-color: rgba(255, 255, 255, 1);\n}\n\n.detail-info {\n  color: #222222;\n}\n\n.detail-title-section {\n  margin-bottom: 32px;\n}\n\n.detail-title {\n  font-size: 32px;\n  font-weight: 500;\n  margin: 0 0 16px 0;\n  line-height: 1.2;\n}\n\n.detail-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.detail-type {\n  background-color: #f7f7f7;\n  color: #222222;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.detail-location {\n  color: #717171;\n  font-size: 14px;\n}\n\n.detail-description h2 {\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0 0 16px 0;\n}\n\n.detail-description p {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #222222;\n  margin: 0;\n}\n\n.detail-actions {\n  margin-top: 32px;\n}\n\n.detail-primary-button {\n  background-color: #ff385c;\n  color: white;\n  text-decoration: none;\n  padding: 14px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  display: inline-block;\n  transition: background-color 0.2s ease;\n}\n\n.detail-primary-button:hover {\n  background-color: #d50027;\n  color: white;\n}\n\n.detail-sidebar {\n  padding: 40px 0;\n  position: sticky;\n  top: 100px;\n}\n\n.detail-card {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.detail-card h3 {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0 0 16px 0;\n  color: #222222;\n}\n\n.detail-contact-item {\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.detail-contact-item:last-child {\n  margin-bottom: 0;\n}\n\n.detail-contact-item strong {\n  font-weight: 500;\n  color: #222222;\n  font-size: 14px;\n}\n\n.detail-contact-item span,\n.detail-contact-item a {\n  color: #717171;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.detail-contact-item a:hover {\n  color: #222222;\n  text-decoration: underline;\n}\n\n.product-price {\n  font-weight: 500;\n  color: #222222;\n  font-size: 16px;\n}\n\n.stock-status {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.stock-status.true,\n.stock-status.yes {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.stock-status.false,\n.stock-status.no {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.creator-item {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.creator-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.creator-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  color: inherit;\n  transition: opacity 0.2s ease;\n}\n\n.creator-link:hover {\n  opacity: 0.8;\n}\n\n.creator-avatar-small {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: #f7f7f7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.creator-avatar-small img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.creator-initials-small {\n  font-size: 14px;\n  font-weight: 500;\n  color: #717171;\n}\n\n.creator-info {\n  flex: 1;\n}\n\n.creator-name {\n  font-weight: 500;\n  color: #222222;\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n.creator-type {\n  color: #717171;\n  font-size: 12px;\n}\n\n/* Item Detail View in Sidebar */\n.item-detail-view {\n  padding: 20px;\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-back-button {\n  background: none;\n  border: none;\n  color: #222222;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n  align-self: flex-start;\n  font-family: inherit;\n}\n\n.detail-back-button:hover {\n  background-color: #f7f7f7;\n}\n\n.detail-image {\n  width: 100%;\n  height: 300px;\n  object-fit: cover;\n  border-radius: 12px;\n  background-color: #f7f7f7;\n}\n\n.detail-header-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-item-title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #222222;\n  margin: 0;\n}\n\n.detail-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.detail-location-text {\n  font-size: 14px;\n  color: #717171;\n}\n\n.detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-section-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #222222;\n  margin: 0;\n}\n\n.detail-description-text {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.detail-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 14px;\n}\n\n.detail-info-item strong {\n  color: #222222;\n  font-weight: 500;\n}\n\n.detail-link {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.detail-link:hover {\n  text-decoration: underline;\n}\n\n.detail-connections {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.connection-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.connection-item:hover {\n  background-color: #e5e5e5;\n}\n\n.connection-name {\n  font-size: 14px;\n  color: #222222;\n  font-weight: 500;\n  flex: 1;\n}\n\n.connection-type {\n  font-size: 12px;\n  color: #717171;\n}\n\n/* Member Detail Page - Behance Style */\n\n.listing-wrapper {\n  min-height: 100vh;\n  background-color: #ffffff;\n  font-family:\n    \"ABC Favorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n}\n\n.listing-cover-image {\n  width: 100%;\n  height: 320px;\n  overflow: hidden;\n  background-color: #f0f0f0;\n}\n\n.listing-cover-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.listing-detail-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 40px 24px;\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 60px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .listing-detail-container {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n}\n\n/* Sidebar */\n.listing-sidebar {\n  position: sticky;\n  top: 100px;\n}\n\n.listing-profile-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 20px;\n  border: 3px solid #ffffff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.listing-profile-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.listing-name {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  color: #111827;\n}\n\n.listing-website-link {\n  display: inline-block;\n  color: #3b82f6;\n  text-decoration: none;\n  font-size: 14px;\n  margin-bottom: 16px;\n  transition: color 0.2s ease;\n}\n\n.listing-website-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.listing-description {\n  margin: 20px 0;\n  padding: 0;\n}\n\n.listing-description p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #374151;\n  margin: 0;\n}\n\n.listing-location {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #6b7280;\n  margin-top: 16px;\n}\n\n.listing-location-icon {\n  font-size: 16px;\n}\n\n.listing-contact-button {\n  width: 100%;\n  padding: 10px 16px;\n  margin-top: 20px;\n  background-color: #111827;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.listing-contact-button:hover {\n  background-color: #374151;\n}\n\n.listing-social-links {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  justify-content: flex-start;\n}\n\n.listing-social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #f3f4f6;\n  color: #374151;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.listing-social-icon:hover {\n  background-color: #e5e7eb;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.listing-event-date {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #6b7280;\n  margin-top: 16px;\n  font-weight: 500;\n}\n\n.listing-date-icon {\n  font-size: 16px;\n}\n\n/* Organizers Section */\n.listing-organizers {\n  margin-bottom: 32px;\n  padding: 20px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n}\n\n.listing-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 16px 0;\n}\n\n.listing-organizers-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.listing-organizer-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: #ffffff;\n  border-radius: 6px;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  border: 1px solid #e5e7eb;\n}\n\n.listing-organizer-item:hover {\n  background-color: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.listing-organizer-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.listing-organizer-name {\n  font-size: 14px;\n  color: #374151;\n  font-weight: 500;\n}\n\n/* Main Content Area */\n.listing-content {\n  min-height: 400px;\n}\n\n/* Tabs */\n.listing-tabs {\n  display: flex;\n  gap: 24px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 32px;\n}\n\n.listing-tab {\n  background: none;\n  border: none;\n  padding: 12px 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n  font-family:\n    \"ABC Favorit\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n}\n\n.listing-tab:hover {\n  color: #111827;\n}\n\n.listing-tab.active {\n  color: #111827;\n}\n\n/* Mobile Stacking */\n@media (max-width: 1024px) {\n  .listing-cover-image {\n    height: 240px;\n  }\n\n  .listing-sidebar {\n    position: static;\n    text-align: center;\n  }\n\n  .listing-profile-image {\n    margin: 0 auto 20px;\n  }\n\n  .listing-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .listing-tab {\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
